import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { paySale, deleteSaleById } from "../../../../services/SaleService";
import currencyBRFormat from "../../../../util/CurrencyUtils";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { maskPhone } from "../../../../util/StringUtils";
import MultiPayment from "../../../../components/Multipayment";
import paymentMethodBR from "../../../../util/paymentMethodUtils";
import { getLoyaltyCardCompleted } from "../../../../services/LoyaltyService";
const dayjs = require("dayjs");

const OPENED = "OPENED";

export const ConcluirVendaModal = (props) => {
  const [sale, setSale] = useState(props.sale);
  const [selectedCustomer, setSelectedCustomer] = useState();
  const inputPaymentMethod = useRef("");
  const [disabledSelect, setDisabledSelect] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [discount, setDiscount] = useState(0.0);
  const [priceWithDiscount, setPriceWithDiscount] = useState(0.0);
  const [totalWithDiscount, setTotalWithDiscount] = useState(0.0);
  const [loading, setLoading] = useState(false);
  const [discountTypePercentual, setDiscountTypePercentual] = useState(true);
  const [adtionalValue, setadtionalValue] = useState(0);
  const [paymentList, setPaymentList] = useState([]);
  const [multiPayment, setMultiPayment] = useState(false);
  const [loyaltyCardInfo, setLoyaltyCardInfo] = useState();
  const [payment, setPayment] = useState("");
  const paymentMethods = [
    { value: "PIX", label: "Pix" },
    { value: "MONEY", label: "Dinheiro" },
    { value: "CREDIT", label: "Crédito" },
    { value: "DEBIT", label: "Débito" },
    { value: "BANK_SLIP", label: "A Prazo" },
  ];

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (sale.customer) {
      setSelectedCustomer({
        value: sale.customer.id,
        label: sale.customer.name,
        key: maskPhone(sale.customer.phone.substring(2)),
      });
      setDisabledSelect(true);
      if (isOpen) {
        getLoyaltyCardCompleted(sale.customer.id).then((response) => {
          if (response) {
            setLoyaltyCardInfo(response);
          }
        });
      }
    }

    setLoyaltyCardInfo();
    setDiscount(0.0);
    setadtionalValue(0);
    setTotalWithDiscount(sale.total);
    setPriceWithDiscount(0.0);
    setDiscountTypePercentual(true);
  }, [isOpen]);

  useEffect(() => {
    if (loyaltyCardInfo && loyaltyCardInfo.completed) setDiscount(100);
  }, [loyaltyCardInfo]);

  const formatCustomersLabels = (customer) => (
    <>
      <span>{customer.label}</span>
      <span> - {customer.key}</span>
    </>
  );

  function deleteSale() {
    const execute = window.confirm(
      `Você tem certeza de que deseja excluir esta venda registrada em ${dayjs(
        sale.createdAt,
      ).format("DD/MM/YYYY")}?`,
    );

    if (execute) {
      deleteSaleById(sale.id)
        .then((response) => {
          props.listSales(OPENED);
          toast.success(response);
        })
        .catch((error) => {
          toast.error("Não foi possível exluir essaa venda");
        });
    }
  }

  function handleSubmit(e) {
    e.preventDefault();

    try {
      validatePaidValue();
      const execute = window.confirm(
        `Revise os detalhes da venda antes de concluir!
        \nSubtotal: ${currencyBRFormat(
          sale.total,
        )}\nValor Adicional: ${currencyBRFormat(
          adtionalValue,
        )}\nDesconto: ${currencyBRFormat(
          priceWithDiscount,
        )}\nTotal: ${currencyBRFormat(totalWithDiscount)}
        \nFormas de pagamento${payment
          ? "\n" +
          paymentMethodBR(payment) +
          ": " +
          currencyBRFormat(totalWithDiscount)
          : paymentList
            .map((p) => "\n" + p.name + ": " + currencyBRFormat(p.value))
            .join("")
        }`,
      );

      if (execute) {
        setLoading(true);
        const data = {
          paymentList: treatMultiPayment(),
          customerId: selectedCustomer ? selectedCustomer.value : null,
          discount: priceWithDiscount ?? 0,
          aditionalValue: adtionalValue ? adtionalValue : 0,
          usingLoyaltyCard: loyaltyCardInfo ? loyaltyCardInfo.completed : false,
        };

        paySale(props.sale.id, data)
          .then((response) => {
            setSelectedCustomer();
            setDisabledSelect(false);
            props.listSales(OPENED);
            setIsOpen(false);
            setLoading(false);
            toast.success("Venda concluída");
          })
          .catch((error) => {
            toast.error("Não foi possível concluir a venda");
            console.error(error);
            setLoading(false);
          });
      }
    } catch (error) {

      console.error(error.message);
      toast.error(error.message);
    }
  }

  useEffect(() => {
    const finalValue = discountTypePercentual ? calculatePercentDiscount() : discount;
    setPriceWithDiscount(isNaN(finalValue) ? 0 : finalValue);
    calculateTotal();
  }, [discountTypePercentual, discount, adtionalValue]);

  function calculatePercentDiscount() {
    return (
      (parseFloat(discount) / 100) *
      (parseFloat(sale.total) + parseFloat(adtionalValue))
    ).toFixed(2);
  }

  function calculateTotal() {
    const finalValue = parseFloat(sale.total) + parseFloat(adtionalValue) - (discountTypePercentual ? calculatePercentDiscount() : discount);
    setTotalWithDiscount(isNaN(finalValue) ? sale.total : finalValue);
  }

  function treatMultiPayment() {
    if (payment) {
      return [{ key: payment, value: totalWithDiscount }];
    }

    return paymentList;
  }

  function validatePaidValue() {
    const paidValue = treatMultiPayment()
      .map((p) => p.value)
      .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
    if (paidValue < totalWithDiscount) {
      throw new Error("Valor das formas de pagamento insufiente");
    }
  }

  function addPayment(paymentMethod, paymentValue) {
    const payment = paymentList.find(
      (p) => p.key == paymentMethod.current.value,
    );

    if (paymentValue && paymentValue > 0) {
      const paidValue = paymentList
        .map((p) => p.value)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

      if (paidValue + parseFloat(paymentValue) > totalWithDiscount) {
        toast.warning(
          `Não pode adicionar pagamento, resta pagar ${currencyBRFormat(
            totalWithDiscount - paidValue,
          )}`,
        );
        return;
      }
      if (payment) {
        toast.warning(
          `Forma de pagamento ${paymentMethodBR(
            paymentMethod.current.value,
          )} já adicionada, remova ou adicione uma diferente`,
        );
        return;
      }
      const item = {
        key: paymentMethod.current.value,
        name: paymentMethodBR(paymentMethod.current.value),
        value: paymentValue,
      };
      setPaymentList((prev) => [...prev, item]);
    } else {
      toast.warning("Valor da forma de pagamento deve ser maior que zero");
    }
  }

  return (
    <div>
      <div className="d-flex">
        <button
          onClick={() => setIsOpen(true)}
          type="button"
          className="btn btn-primary"
        >
          Receber
        </button>

        <button
          type="button"
          className="btn btn-danger mx-3"
          onClick={deleteSale}
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>

      <Modal
  isOpen={isOpen}
  toggle={() => setIsOpen(false)}
  backdrop="static"
  size="lg"
  centered
  contentClassName="border-0 rounded-4 shadow-lg"
>
  <ModalHeader toggle={toggle} className="border-bottom-0 pb-0 pt-4 px-4">
    <span className="fw-bold text-primary">Concluir Venda</span>
  </ModalHeader>

  {loyaltyCardInfo && loyaltyCardInfo.completed && (
    <div className="mx-4 mt-3 alert alert-primary border-0 shadow-sm d-flex align-items-center" role="alert">
      <i className="fas fa-gift me-2"></i>
      <strong className="fw-bold">Parabéns! Este cliente completou o Cartão Fidelidade.</strong>
    </div>
  )}

  <form onSubmit={handleSubmit}>
    <ModalBody className="p-4">
      {/* SEÇÃO 1: PAGAMENTO E CLIENTE */}
      <div className="row mb-4">
        <div className="col-lg-6 mb-lg-0 mb-3">
          <div className="bg-light p-3 rounded-3 border h-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <label className="form-label fw-bold text-muted small text-uppercase mb-0">
                <i className="fas fa-cash-register me-1"></i> Pagamento
              </label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input cursor-pointer"
                  type="checkbox"
                  id="switchPaymentMethod"
                  checked={multiPayment}
                  onChange={() => setMultiPayment(!multiPayment)}
                />
                <label className="form-check-label small fw-bold" htmlFor="switchPaymentMethod">
                  {multiPayment ? "Várias" : "Uma"}
                </label>
              </div>
            </div>

            {multiPayment ? (
              <MultiPayment
                inputPaymentMethod={inputPaymentMethod}
                paymentList={paymentList}
                addPayment={addPayment}
                setPaymentList={setPaymentList}
                totalWithDiscount={totalWithDiscount}
              />
            ) : (
              <div className="d-flex flex-wrap gap-2">
                {paymentMethods.map((item) => (
                  <button
                    key={item.label}
                    type="button"
                    className={`btn btn-sm rounded-pill px-3 fw-bold transition-all ${
                      payment === item.value ? "btn-primary shadow-sm" : "btn-outline-secondary opacity-75"
                    }`}
                    onClick={() => setPayment(item.value)}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-6">
          <div className="bg-light p-3 rounded-3 border h-100">
            <label htmlFor="customerSelect" className="form-label fw-bold text-muted small text-uppercase">
              <i className="fas fa-user me-1"></i> Cliente
            </label>
            <Select
              isDisabled={disabledSelect}
              onChange={(customer) => setSelectedCustomer(customer)}
              id="customerSelect"
              name="customers"
              classNamePrefix="select"
              options={props.customers}
              value={selectedCustomer}
              formatOptionLabel={formatCustomersLabels}
              placeholder="Selecione o cliente..."
              styles={{
                control: (base) => ({ ...base, borderRadius: '8px', border: '1px solid #dee2e6' })
              }}
            />

            {loyaltyCardInfo && (
              <div className="mt-3">
                <div className="d-flex justify-content-between mb-1">
                  <span className="small fw-bold text-muted">Progresso Fidelidade</span>
                  <span className="small fw-bold text-primary">{loyaltyCardInfo.servicesCount} serviços</span>
                </div>
                <div className="progress rounded-pill shadow-sm" style={{ height: '10px' }}>
                  <div
                    className="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                    style={{ width: loyaltyCardInfo.percentProgress }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* SEÇÃO 2: TABELA DE ITENS */}
      <div className="border rounded-3 overflow-hidden mb-4">
        <table className="table table-hover mb-0">
          <thead className="table-light">
            <tr className="small text-uppercase text-muted">
              <th className="px-3">Qtd</th>
              <th>Descrição</th>
              <th className="text-end px-3">Preço</th>
            </tr>
          </thead>
          <tbody>
            {props.sale.servicesAndParts.map((obj) => (
              <tr key={obj.name}>
                <td className="px-3 fw-bold">{obj.qtd}</td>
                <td>{obj.name}</td>
                <td className="text-end px-3 fw-medium">{currencyBRFormat(obj.price)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* SEÇÃO 3: ADICIONAIS E DESCONTOS */}
      <div className="row g-3 p-3 bg-light rounded-3 border mx-0">
        <div className="col-lg-4">
          <label className="form-label fw-bold text-muted small text-uppercase">Valor Adicional</label>
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">R$</span>
            <input
              className="form-control border-start-0 fw-bold"
              type="number"
              value={adtionalValue}
              onChange={(e) => setadtionalValue(e.target.value)}
              min={0}
            />
          </div>
        </div>

        <div className="col-lg-4">
          <label className="form-label fw-bold text-muted small text-uppercase">Tipo de Desconto</label>
          <div className="form-check form-switch pt-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="switchDiscountType"
              checked={discountTypePercentual}
              onChange={() => setDiscountTypePercentual(!discountTypePercentual)}
            />
            <label className="form-check-label small fw-bold" htmlFor="switchDiscountType">
              {discountTypePercentual ? "Percentual (%)" : "Valor Fixo (R$)"}
            </label>
          </div>
        </div>

        <div className="col-lg-4">
          <label className="form-label fw-bold text-muted small text-uppercase">Desconto</label>
          <input
            className="form-control fw-bold border-primary-subtle shadow-sm"
            value={discount}
            disabled={loyaltyCardInfo && loyaltyCardInfo.completed}
            onChange={(e) => setDiscount(e.target.value)}
            id="desconto"
            type="text"
            placeholder={discountTypePercentual ? "0%" : "R$ 0,00"}
          />
        </div>
      </div>

      {/* SEÇÃO 4: RESUMO FINANCEIRO (HIGHLIGHT) */}
      <div className="row mt-4 g-2 text-center">
        <div className="col-lg-3">
          <div className="p-2 border rounded-3 bg-white shadow-sm h-100">
            <div className="small text-muted fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Subtotal</div>
            <div className="fw-bold text-dark">{currencyBRFormat(sale.total)}</div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="p-2 border rounded-3 bg-white shadow-sm h-100">
            <div className="small text-muted fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Adicional</div>
            <div className="fw-bold text-primary">+{currencyBRFormat(adtionalValue)}</div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="p-2 border rounded-3 bg-white shadow-sm h-100">
            <div className="small text-muted fw-bold text-uppercase" style={{ fontSize: '0.65rem' }}>Desconto</div>
            <div className="fw-bold text-danger">-{currencyBRFormat(priceWithDiscount)}</div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="p-2 border rounded-3 bg-success text-white shadow h-100">
            <div className="small fw-bold text-uppercase opacity-75" style={{ fontSize: '0.65rem' }}>Total Final</div>
            <div className="h5 fw-bold mb-0">{currencyBRFormat(totalWithDiscount)}</div>
          </div>
        </div>
      </div>
    </ModalBody>

    <ModalFooter className="border-top-0 p-4 pt-0">
      {!loading ? (
        <div className="d-flex w-100 gap-2">
          <button type="submit" className="btn btn-primary btn-lg fw-bold flex-grow-1 rounded-3 shadow-sm">
            <i className="fas fa-check-circle me-2"></i> Concluir Venda
          </button>
          <button type="button" onClick={() => setIsOpen(false)} className="btn btn-outline-danger btn-lg rounded-3 border-2">
            Cancelar
          </button>
        </div>
      ) : (
        <div className="d-flex justify-content-center w-100">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Concluindo...</span>
          </div>
        </div>
      )}
    </ModalFooter>
  </form>
</Modal>
    </div>
  );
};

export default ConcluirVendaModal;
